import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class PhotographerService {
	private baseUrl: string;
	private imgValidFileExtensions: string[] = ['jpg', 'jpeg', 'png'];

	constructor(
		private appService: AppService,
		private utilitiesService: UtilitiesService
	) {
		this.baseUrl = this.appService.utilsUrls.apiUrl;
	}

	/*
	public getCompanies(loaderId?: string): Observable<Company[]> {
		const url = this.baseUrl + '/Photographer/GetCompanies';
		return this.studiosHttpClient.get<Company[]>(
			url,
			{
				params: { currentUserId: this.appService.user.userId.toString(), photographerId: this.appService.photographerId.toString() }
			},
			loaderId
		);
	}

	public sendCollaborationRequest(companyId: number, loaderId?: string): Observable<number> {
		const url = this.baseUrl + '/Photographer/SendCollaborationRequest';
		return this.studiosHttpClient.post<number>(
			url,
			null,
			{
				params: { 
					currentUserId: this.appService.user.userId.toString(),
					personId: this.appService.photographerId.toString()
				}
			},
			loaderId
		);
	}

	public getPhotographerOrderDetails(orderId: number, loaderId?: string): Observable<OrderDetailsSchema<PhotographerOrderDetails>> {
		const url = this.baseUrl + '/Photographer/GetPhotographerOrderDetails';
		return this.studiosHttpClient.get<OrderDetailsSchema<PhotographerOrderDetails>>(
			url,
			{
				params: { photographerId: this.appService.photographerId.toString(), orderId: orderId.toString() }
			},
			loaderId
		);
	}

	public getPhotographerUploadedShots(orderId: number, loaderId?: string): Observable<UploadedShot[]> {
		const url = this.baseUrl + '/Photographer/GetPhotographerUploadedShots';
		return this.studiosHttpClient.get<UploadedShot[]>(
			url,
			{
				params: { photographerId: this.appService.photographerId.toString(), orderId: orderId.toString() }
			},
			loaderId
		);
	}

	public assignShot(orderImageId: number, shotId: number, loaderId?: string): Observable<number> {
		const url = this.baseUrl + '/Photographer/AssignShot';
		const body: AssignShotData = { OrderImageId: orderImageId, ShotId: shotId };
		return this.studiosHttpClient.post<number>(
			url,
			body,
			{
				params: { currentUserId: this.appService.user.userId.toString() }
			},
			loaderId
		);
	}

	public subShot(orderImageId: number, shotId: number, loaderId?: string, invert?: number): Observable<number> {
		const url = this.baseUrl + '/Photographer/SubstitutionShot';
		const body: SubstitutionShotData = { OrderImageId: orderImageId, ShotId: shotId, Invert: invert ?? 0 };
		return this.studiosHttpClient.post<number>(
			url,
			body,
			{
				params: { currentUserId: this.appService.user.userId.toString() }
			},
			loaderId
		);
	}

	public getOrderImageId(shotId: number, loaderId?: string): Observable<number> {
		const url = this.baseUrl + '/Photographer/GetOrderImageId';
		return this.studiosHttpClient.get<number>(
			url,
			{
				params: { shotId: shotId.toString() }
			},
			loaderId
		);
	}

	
	public getPhotographerRejectedShots(loaderId?: string): Observable<PhotographerRejectedShot[]> {
		const url = this.baseUrl + '/Photographer/GetPhotographerRejectedShots';
		return this.studiosHttpClient.get<PhotographerRejectedShot[]>(
			url,
			{
				params: { photographerId: this.appService.photographerId.toString() }
			},
			loaderId
		);
	}

	public deleteShot(orderImageId: number, loaderId?: string): Observable<number> {
		const body = new DeleteShot(orderImageId, null);
		const url = this.baseUrl + '/Photographer/DeleteShot';
		return this.studiosHttpClient.post<number>(
			url,
			body,
			{
				params: { currentUserId: this.appService.user.userId.toString() }
			},
			loaderId
		);
	}

	public getStylesToShoot(warehouseId: number, paginationPage: number, paginationSize: number, search?: string, loaderId?: string): Observable<PhotographerStyle[]> {
		const url = this.baseUrl + '/Photographer/GetStylesToShoot';
		return this.studiosHttpClient.get<PhotographerStyle[]>(
			url,
			{
				params: {
					currentUserId: this.appService.user.userId.toString(),
					photographerId: this.appService.photographerId.toString(),
					warehouseId: warehouseId.toString(),
					paginationPage: paginationPage.toString(),
					paginationSize: paginationSize.toString(),
					search: search || ''
				}
			},
			loaderId
		);
	}

	public getPhotographerMaxItems(loaderId?: string): Observable<number> {
		const url = this.baseUrl + '/Photographer/GetPhotographerMaxItems';
		return this.studiosHttpClient.get<number>(
			url,
			{
				params: {
					currentUserId: this.appService.user.userId.toString(),
					photographerId: this.appService.photographerId.toString()
				}
			},
			loaderId
		);
	}*/
}
